
import { functions,auth } from "@/scripts/firebase"
import {httpsCallable} from 'firebase/functions'
import { NoticeProps } from "@/scripts/datatypes"
import { ValidationObserver } from 'vee-validate'

import { Component,Mixins } from "vue-property-decorator";
import Common from '@/mixins/common';
import { CreateSchoolArg, CreateSchoolRes } from "@/common-datatypes";

@Component({
  components: {
    
  }
})

export default class AddSchool extends Mixins(Common) {
  isLoading = false
  schoolName = ''
  notice: NoticeProps = {} 
  
  get observer() {
    return this.$refs.addSchoolValidationObserver as InstanceType<typeof ValidationObserver>;
  }

  get isDisabled(){
    return ! this.schoolName
  }

  async created(){
    console.trace('created');
  }
 
 async mounted(){
  console.trace('mounted');
 }

  destroyed() {
    console.trace('destroyed');
  }

  public async addSchool() {
    try{
      this.notice = {
        isShow: false,
      }

      if(! await this.observer.validate()){
        return
      }

      this.$store.commit("setLoading",true);
      this.isLoading = true
   
      const createSchool = httpsCallable(functions,'createSchool');

      const data: CreateSchoolArg = {
        schoolName: this.schoolName,
        schoolId: this.$store.getters.schoolId,
        lang: this.$store.getters.lang
      }

      const newSchool = await createSchool(data) as {data: CreateSchoolRes}

      console.log(newSchool)
      //this.$store.commit("setSchoolId", newSchool.data.schoolId);

      this.notice = {
        message: this.$t('addSchool.added') as string,
        duration: 0,
        isShow: true,
        type: {'is-info': true}
      }

      this.schoolName = ''
      this.observer.reset()

      await this.$sleep(2000)
      await auth.currentUser?.getIdToken(true)

      this.$router.push({name: 'dashboard'})
    }catch(error){
      console.table(error)
      const errorCode = this.$getErrorCode(error)
      const errorMessage0 = this.$t('addSchool.error') as string

      const errorMessage1 = this.$t(this.$getErrorMessageKey(errorCode)) as string

      const errorField = this.$getErrorField(errorCode)

      if(errorMessage1 && errorField){
        this.observer.setErrors({
         [errorField]: errorMessage1
        })
      }

      const errorMessage = (errorMessage1 === '') ? errorMessage0 : errorMessage0 + '<br />' + errorMessage1
      this.notice = {
        message: errorMessage,
        isShow: true,
        type: {'is-danger': true}
			}
    }finally{
      this.$store.commit("setLoading",false);
      this.isLoading = false
    }
  }
}
